import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Context from "./Context";
import AlertModal from "./components/Alert";
import OfflineBanner from "./components/OfflineBanner";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// ── Single-tab guard (runs synchronously before React mounts) ─────────────────
(function enforeSingleTab() {
  const TAB_KEY = "app_active_tab";
  const TAB_ID = `tab_${Date.now()}_${Math.random().toString(36).slice(2)}`;

  if (localStorage.getItem("token")) {
    if (localStorage.getItem(TAB_KEY)) {
      // Another tab is already open — redirect before React mounts
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("name");
      window.location.replace("/admin?reason=duplicate_tab");
      // Prevent the rest of this script from running
      document.addEventListener(
        "DOMContentLoaded",
        function (e) {
          e.stopImmediatePropagation();
        },
        true,
      );
      return;
    }
    // Claim the slot
    localStorage.setItem(TAB_KEY, TAB_ID);
    window.addEventListener("beforeunload", () => {
      if (localStorage.getItem(TAB_KEY) === TAB_ID) {
        localStorage.removeItem(TAB_KEY);
      }
    });
  }
})();
// ─────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Context>
    <AlertModal />
    <OfflineBanner />
    <App />
  </Context>,
);

serviceWorkerRegistration.register({
  onSuccess: () => console.log("App is cached for offline use."),
  onUpdate: () => console.log("New version available. Reloading..."),
});

reportWebVitals();
